import { ConfigurationMainModel } from 'franke-trough-dependencies';

export const getResetDispatchData = (configuration: ConfigurationMainModel, items?: string[]): ConfigurationMainModel | undefined => {
  if (items && items.length > 0 && configuration) {
    const data: ConfigurationMainModel | {} = {};
    Object.keys(configuration).forEach(keys => {
      if (configuration && configuration[keys]) {
        const itemKeys = Object.keys(configuration[keys]);
        let hasKey = false; 
        items.forEach(item => {
          if (itemKeys.indexOf(item) > -1) {
            hasKey = true;
          }
        });
        if (hasKey) {
          data[keys] = configuration[keys];
        }
      }
    });
    return data as ConfigurationMainModel;
  }
  return;
};
